import axios from "axios";
import Cookies from "js-cookie";

// 🧠 Build dynamic headers
const token = localStorage.getItem("token");
const header = token
  ? { "x-access-token": token }
  : { "user-type": "appUser" };

header["company-code"] = "GJ";
header["language"] =
  localStorage.getItem("GJLangCode")?.toUpperCase() ||
  Cookies.get("GJLangCode")?.toUpperCase() ||
  "EN";

// 🗺 Country logic
let countryId =
  localStorage.getItem("country") ||
  JSON.parse(localStorage.getItem("profile") || "{}")?.country?._id;

if (
  countryId &&
  countryId !== "undefined" &&
  countryId !== "null" &&
  countryId !== ""
) {
  header["country"] = countryId.replace(/"/g, "");
}

header["user-id"] = localStorage.getItem("user-id") || "";

// 🔧 Create axios instance WITHOUT baseURL
const instance = axios.create({
  timeout: 40000,
  headers: header,
});

// 🧼 Clean empty strings → null
instance.interceptors.request.use(
  (config) => {
    if (config.data && typeof config.data === "object") {
      for (let key in config.data) {
        if (config.data[key] === "") {
          config.data[key] = null;
        }
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 🔒 Handle unauthorized access (401)
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default instance;
